import { Outlet, ScrollRestoration, useLocation } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { useStore } from "../stores/store";
import { useEffect, useState } from "react";
import LoadingComponent from "./LoadingComponent";
import ModalContainer from "../common/modals/ModalContainer";
import WelcomePage from "../../features/home/WelcomePage";
import i18n from "../i18n";
import NavBar from "./NavBar";
import Box from "@mui/material/Box";
import { useMediaQuery, useTheme } from "@mui/material";

function App() {
  const location = useLocation();
  const token = useStore((s) => s.commonStore.token);
  const setAppLoaded = useStore((s) => s.commonStore.setAppLoaded);
  const appLoaded = useStore((s) => s.commonStore.appLoaded);
  const getUser = useStore((s) => s.userStore.getUser);
  const isLoggedIn = useStore((s) => s.userStore.isLoggedIn);
  const uiStore = useStore((s) => s.uiStore);
  const storedLanguage = localStorage.getItem("selectedLanguage");
  const [selectedLanguage, setSelectedLanguage] = useState(
    storedLanguage || i18n.language
  );
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const drawerOpen = uiStore.sidebarOpen;
  const SIDEBAR_WIDTH = 270;
  const SIDEBAR_COLLAPSED_WIDTH = 56;
  const mainContentMarginLeft = drawerOpen ? SIDEBAR_WIDTH : SIDEBAR_COLLAPSED_WIDTH;

  useEffect(() => {
    localStorage.setItem("selectedLanguage", selectedLanguage);
    i18n.changeLanguage(selectedLanguage);
  }, [selectedLanguage]);

  useEffect(() => {
    if (token) {
      getUser().finally(() => setAppLoaded());
    } else {
      setAppLoaded();
    }
  }, [token, getUser, setAppLoaded]);

  if (!appLoaded)
    return <LoadingComponent content="Loading app..." />;

  return (
    <>
      <ScrollRestoration />
      <ModalContainer />
      <ToastContainer position="bottom-right" hideProgressBar theme="colored" />
      {location.pathname === "/" ? (
        <WelcomePage />
      ) : (
        <>
          <NavBar />
          <Box
            sx={{
              mt: { xs: "5em", sm: "7em" },
              ml: isLoggedIn ? { xs: 0, sm: `${mainContentMarginLeft}px` } : 0,
              transition: "margin-left 0.2s",
              width: "auto",
              maxWidth: "100%",
              px: { xs: 1, sm: 2, md: 3 },
              boxSizing: "border-box",
              overflowX: "unset",
            }}
          >
            <Box
              sx={{
                width: "100%",
                maxWidth: "1800px",
                mx: "auto",
                minHeight: "calc(100vh - 7em)",
                display: "flex",
                flexDirection: "column",
              }}
            >
              <Outlet />
            </Box>
          </Box>
        </>
      )}
    </>
  );
}

export default App;
